import { pick } from 'lodash';
import type { PostAssessmentResponse } from './types';

// Currently only used for creating assessment responses - also saves the test
// instance responses items. We should be able to reuse this code for surveys
// responses in the future, replacing prepareTestInstanceResponse.
export const prepareAssessmentResponse = (
  testInstanceResponse: Partial<PostAssessmentResponse>
): MutationBody => ({
  data: {
    type: 'TestInstanceResponse',
    attributes: {
      ...pick(testInstanceResponse, ['status']),
      session: testInstanceResponse.session
    },
    relationships: {
      ...(testInstanceResponse.testInstance
        ? {
            testInstance: {
              data: {
                id: `/api/v2/test-instances/${testInstanceResponse.testInstance}`,
                type: 'TestInstance'
              }
            }
          }
        : {}),
      ...(testInstanceResponse.token
        ? {
            token: {
              data: { id: `/api/v2/tokens/${testInstanceResponse.token}`, type: 'Token' }
            }
          }
        : {}),
      ...(testInstanceResponse.user
        ? {
            user: {
              data: {
                id: `/api/v2/users-test-instances/${testInstanceResponse.user}`,
                type: 'UsersTestInstances'
              }
            }
          }
        : {}),
      ...(testInstanceResponse.testInstanceResponseItems
        ? {
            responseItems: {
              data: testInstanceResponse.testInstanceResponseItems.map((_, index) => ({
                lid: `${index + 1}`.toString(),
                type: 'TestInstanceResponseItem'
              }))
            }
          }
        : {})
    }
  },
  ...(testInstanceResponse.testInstanceResponseItems
    ? {
        included: testInstanceResponse.testInstanceResponseItems.map((item, index) => ({
          lid: `${index + 1}`.toString(),
          type: 'TestInstanceResponseItem',
          attributes: {
            inputType: 'manual',
            ...pick(item, ['submittedValue'])
          },
          relationships: {
            ...(item.testItem
              ? {
                  testItem: {
                    data: {
                      id: `/api/v2/test-items/${item.testItem}`,
                      type: 'TestItem'
                    }
                  }
                }
              : {}),
            ...(item.submittedOptions
              ? {
                  submittedOptions: {
                    data: item.submittedOptions?.map((option) => ({
                      id: `/api/v2/test-item-options/${option}`,
                      type: 'TestItemOption'
                    }))
                  }
                }
              : {})
          }
        }))
      }
    : {})
});
